/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const GLFactorService = {
  async getByCode(code, select) {
    const requestScreenData = {
      url: "api/GLFactor",
      top: "1",
      filter: `Code eq ${code}`,
      select: select ? select : undefined
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getByChartCode(GLChartCode) {
    const requestScreenData = {
      url: "api/GLFactor",
      top: "1",
      filter: `GLChartCode eq ${GLChartCode}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { GLFactorService };
